<template>
    <div>
        <div>
            审核状态：
            <el-select v-model="status" @change="getList({status:$event})">
                <el-option
                        v-for="item of statusOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"/>
            </el-select>
            <div class="common-search">
                <el-input
                        class="common-el-input"
                        placeholder="请输入玩家ID查询"
                        v-model="searchVal">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="getList()">搜索</el-button>
            </div>
        </div>
        <div class="common-table">
            <el-table v-loading="loading" :data="accountPayeeCheckList.beanList" height="100%"
                      :row-class-name="tableRowClassName" row-key="id">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="玩家昵称" width="120" align="center" prop="userNickname"/>
                <el-table-column label="玩家ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="俱乐部昵称" width="150" align="center" prop="clubName"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubRandomId"/>
                <el-table-column label="联盟昵称" width="150" align="center" prop="tribeName"/>
                <el-table-column label="联盟ID" align="center" prop="tribeRandomId"/>
                <el-table-column label="支付宝" width="150" align="center" prop="alipayAccount"/>
                <el-table-column label="银行卡" width="180" align="center" prop="bankAccount"/>
                <el-table-column label="联系方式" width="120" align="center" prop="contact"/>
                <el-table-column label="提交审核时间" align="center" width="180" prop="submitTime"/>
                <el-table-column label="审核状态" align="center">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === 0" size="mini" type="primary"
                                   @click="showInfo(scope.row)">待审核
                        </el-button>
                        <span v-else-if="scope.row.status === 1" style="color: #67C23A">已同意</span>
                        <span v-else style="color: red">已拒绝</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="accountPayeeCheckList.total"
                :current-page="currentPage"
                @current-change="getList({page:$event})"/>

        <div v-if="infoRow" class="common-popup-bg">
            <div class="common-popup">
                <i class="common-popup-close el-icon-close" @click="infoRow = null"></i>
                <h3>玩家修改提豆账号信息</h3>
                <div class="header">
                    <div>玩家昵称：{{infoRow.userNickname}}({{infoRow.userRandomId}})</div>
                </div>
                <el-tabs class="tabs" tab-position="left">
                    <el-tab-pane v-if="accountPayeeCheckInfo.type===2" label="支付宝">
                        <div class="common-table">
                            <el-table :data="accountPayeeCheckInfo.alipayInfos" height="100%">
                                <el-table-column label="支付宝账号" align="center" prop="alipayAcc"/>
                                <el-table-column label="实名认证姓名" align="center" prop="alipayRealName"/>
                            </el-table>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane v-if="accountPayeeCheckInfo.type===1" label="银行卡">
                        <div class="common-table">
                            <el-table :data="accountPayeeCheckInfo.bankInfos" height="100%">
                                <el-table-column label="户名" align="center" prop="bankAccName"/>
                                <el-table-column label="银行卡号" align="center" prop="bankAccNo"/>
                                <el-table-column label="银行名称" align="center" prop="bankName"/>
                                <el-table-column label="开户行" align="center" prop="bankOfDeposit"/>
                                <el-table-column label="开户行所在地" align="center">
                                    <template slot-scope="scope">
                                        {{scope.row.bankLocProvince}}{{scope.row.bankLocCity}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <footer>
                    <el-button @click="rejectFunc" size="small" type="danger">拒绝</el-button>
                    <el-button @click="agreeFunc" size="small" type="success">同意</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                show: false,
                searchVal: '',
                status: '',
                statusOptions: [
                    {label: '全部', value: ''},
                    {label: '未审核', value: '0'},
                    {label: '已同意', value: '1'},
                    {label: '已拒绝', value: '2'},
                ],
                currentPage: 1,
                infoRow: null,// 要审核的信息ID
            }
        },
        computed: {
            ...mapState('accountPayeeCheck', ['accountPayeeCheckList', 'accountPayeeCheckInfo'])
        },
        created() {
            this.getList();
        },
        methods: {
            ...mapActions('accountPayeeCheck', ['getAccountPayeeCheckList', 'getAccountPayeeCheckInfo', 'agreeAccountPayeeCheck', 'rejectAccountPayeeCheck']),
            getList(obj = {}) {
                this.loading = true;
                let params = {
                    userRandomId: this.searchVal,
                    status: this.status,
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getAccountPayeeCheckList(params).then(() => {
                    this.loading = false;
                })
            },
            showInfo(row) {
                this.getAccountPayeeCheckInfo(row.id).then(() => {
                    this.infoRow = row;
                })
            },
            agreeFunc() {
                this.agreeAccountPayeeCheck(this.infoRow.id).then(() => {
                    this.infoRow = null;
                    this.getList({page: this.currentPage})
                })
            },
            rejectFunc() {
                this.rejectAccountPayeeCheck(this.infoRow.id).then(() => {
                    this.infoRow = null;
                    this.getList({page: this.currentPage})
                })
            },
            tableRowClassName({row}) {
                if (row.status === 1) {
                    return 'success-row';
                } else if (row.status === 2) {
                    return 'warning-row';
                }
                return '';
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        padding: 10px;
    }

    .tabs {
        height: 300px;
        width: 800px;
        background: #fff;
        :global(.el-tab-pane) {
            display: flex;
            flex-flow: column;
            height: 300px;
        }
        .common-table {
            margin: 0 10px 0 0;
            :global(.el-table::before) {
                height: 0;
            }
        }
        :global(table) {
            padding: 0;
        }
    }
</style>